/**
 * /my-coaching/welcome — the coach's front door. A coach under review gets it
 * too. A revoked coach goes to the dashboard, which shows her state.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

import { callsAndLinksQueryOptions } from "~/lib/queries/callsAndLinksQuery";
import { placementVideosQueryOptions } from "~/lib/queries/learningQuery";
import {
  myClientRevenueEstimateQueryOptions,
  myReadinessQueryOptions,
} from "~/lib/queries/readinessQuery";

import { WelcomePage } from "./-components/welcome-page";

export const Route = createFileRoute("/_user/my-coaching/welcome")({
  staticData: { title: "Welcome" },
  beforeLoad: ({ context }) => {
    if (context.isRevoked) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  loader: async ({ context }) => {
    // A missing video is a page without its video, a missing score shows the
    // card for a coach without one, and a missing Book-a-call link keeps the
    // path to six figures; none is an error page.
    await Promise.all([
      context.queryClient
        .ensureQueryData(placementVideosQueryOptions())
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(myReadinessQueryOptions())
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(callsAndLinksQueryOptions())
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(myClientRevenueEstimateQueryOptions())
        .catch(() => undefined),
    ]);
  },
  component: WelcomePage,
});
